"use strict";

import Vue from 'vue';
import axios from "axios";


const urlHostname = location.protocol + '//' + location.hostname
var urlPort = (location.port ? ':' + location.port : '');
axios.defaults.baseURL = urlHostname + urlPort + '/api/'
    // specify URL for local dev
    // For development, please change the port number below in accordance with your local environment
if (location.hostname === '127.0.0.1' || location.hostname === 'localhost') {
    urlPort = 80
    axios.defaults.baseURL = 'http://int-yachtcover.map.mrshmc.com/api/'
}
var accessUrl = '//dev-api.map.mrshmc.com/api/accesslog';
switch (location.hostname) {
    case "int-yachtcover.map.mrshmc.com":
        accessUrl = "//dev-api.map.mrshmc.com/api/accesslog";
        break;
    case "uat-yachtcover.map.marsh.com":
        accessUrl = "//uat-api.map.marsh.com/api/accesslog";
        break;
    case "yachtcover.map.marsh.com":
        accessUrl = "//api.map.marsh.com/api/accesslog";
        break;
}



let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function(config) {
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

_axios.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        return Promise.reject(error);
    }
);

export default {
    getMasterData(callBack) {
        return axios
            .get('/masterdata')
            .then((response) => {
                callBack(response.data)
            })
            .catch((e) => {
                if (e.response) {
                    console.log('got response from server.', e)
                    if (e.response.status >= 500) {
                        alert(e.response.data.Message)
                    } else {
                        alert(e.message)
                    }
                } else if (e.request) {
                    console.log('no response from server.')
                    console.log('Message:' + e.message)
                } else {
                    console.log('getMasterData error!:' + e.message)
                }
            })
    },
    postClaim(item, callBack) {
        return axios
            .post('/application', item)
            .then((response) => {
                callBack(response)
            })
            .catch((e) => {
                if (e.response) {
                    console.log(e.response)
                    console.log(e.response.data.code)
                } else if (e.request) {
                    console.log('no response from server.')
                    console.log('Message:' + e.message)
                } else {
                    console.log('getMasterData error!:' + e.message)
                }
                callBack(e.response)
            })
    },
    getIpAddress(callBack) {
        return axios
            .get('https://www.cloudflare.com/cdn-cgi/trace')
            .then((response) => {
                callBack(response.data)
            })
    },
    logAccess(item, callBack) {
        return item;
        // if (item.ip !== null) {
        //     return axios
        //         .post(accessUrl, item)
        //         .then((response) => {
        //             callBack(response)
        //         })
        //         .catch((e) => {
        //             if (e.response) {
        //                 console.log(e.response)
        //                 console.log(e.response.data.code)
        //             } else if (e.request) {
        //                 console.log('no response from server.')
        //                 console.log('Message:' + e.message)
        //             } else {
        //                 console.log('getMasterData error!:' + e.message)
        //             }
        //             callBack(e.response)
        //         })
        // }
    },
}